import { useEffect, useState } from "react";

export function BeforeAfterDemo() {
	const [showAfter, setShowAfter] = useState(false);

	useEffect(() => {
		const timer = setInterval(() => {
			setShowAfter((prev) => !prev);
		}, 2500);
		return () => clearInterval(timer);
	}, []);

	return (
		<div className="max-w-xs mx-auto sm:max-w-sm">
			<div
				className="relative cursor-pointer rounded-2xl overflow-hidden border border-gray-200 shadow-xl select-none"
				onClick={() => setShowAfter((prev) => !prev)}
			>
				<img
					src="/demo/before.webp"
					alt="背景除去前"
					className="w-full block"
					draggable={false}
				/>
				<img
					src="/demo/after.webp"
					alt="背景除去後"
					className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${showAfter ? "opacity-100" : "opacity-0"}`}
					draggable={false}
				/>
				<p className="absolute bottom-2 right-2 text-sm text-white bg-black/40 px-2 py-0.5 rounded-full">
					タップで切替
				</p>
			</div>
			<div className="flex justify-center gap-2 mt-3">
				<button
					onClick={() => setShowAfter(false)}
					className={`flex items-center justify-center w-12 h-12 rounded-full transition-colors ${!showAfter ? "text-gray-700" : "text-gray-300"}`}
					aria-label="Before"
				>
					<span
						className={`w-2 h-2 rounded-full ${!showAfter ? "bg-gray-700" : "bg-gray-300"}`}
					/>
				</button>
				<button
					onClick={() => setShowAfter(true)}
					className={`flex items-center justify-center w-12 h-12 rounded-full transition-colors ${showAfter ? "text-green-500" : "text-gray-300"}`}
					aria-label="After"
				>
					<span
						className={`w-2 h-2 rounded-full ${showAfter ? "bg-green-500" : "bg-gray-300"}`}
					/>
				</button>
			</div>
		</div>
	);
}
